export enum IntegrationType {
  OWNERREZ = 'OwnerRez',
  HOSPITABLE = 'Hospitable',
  HOSPITABLE_CONNECT = 'Hospitable Connect',
  HOSTAWAY = 'Hostaway',
  GUESTY = 'Guesty',
  GUESTY_LITE = 'Guesty Lite',
  LODGIFY = 'Lodgify',
  TURNO = 'Turno',
  // This is the name of the custom API integration
  STAYFI = 'stayfi',
  HOSTFULLY = 'Hostfully',
  HOST_TOOLS = 'Host Tools',
  HAVEN = 'Haven',
  HOSTBUDDY = 'HostBuddy',
}
